import React from 'react'
import Portfolio from '../../Components/Portfolio'
import "./portfolioPage.scss"

const PortfolioPage = () => {
  return (
    <Portfolio number={Infinity} btn={false} />
  )
}

export default PortfolioPage